
// Service for global user indicators, like loading icons and error messages.
export default class ResponsiveService {
    isTouchEnabled() {
        return typeof document !== 'undefined' && document.documentElement.clientWidth <= 991;
    }
}
